import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "DocumentCompanyAddress"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { computed, PropType } from "vue";
import { Client, Document, Company } from "@/types";
import InnSelect from "@/components/ds/select/Select.vue";
import { useEmployeeStore } from "@/stores/employees";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentCompanyAddress',
  props: {
    document: {
        type: Object as PropType<Document>,
        required: true,
    },
    client: {
        type: Object as PropType<Client>,
        required: true,
    },
    company: {
        type: Object as PropType<Company>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const employeesStore = useEmployeeStore();

const employee = computed(() => {
    return employeesStore.getItemById(props.document.user_id);
});

return (_ctx: any,_cache: any) => {
  return (__props.company)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("b", null, _toDisplayString(__props.company.name), 1)
        ]),
        (!__props.company.companySameAsEmployee)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (employee.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(employee.value.name), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, _toDisplayString(__props.company.address), 1),
        _createElementVNode("div", null, _toDisplayString(__props.company.zipcode) + " " + _toDisplayString(__props.company.city), 1),
        (__props.client.international)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.company.country), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})